var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLevel3Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#e7e9e8;}.cls-3{fill:#afc07c;}.cls-4{fill:#64783f;}.cls-5{fill:#465425;}.cls-6{fill:#af955c;}.cls-7{fill:#819552;}.cls-8{fill:#f1f1f1;}.cls-9{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "niveau3_selected",
    "data-name": "niveau3 selected"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.76,25.89a6.29,6.29,0,0,1,4.33,1.86L39.28,37.94a6.31,6.31,0,0,1,1.86,4.45H47L28,14.18l-5.36,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.51 31.31 16.46 31.31 16.34 31.48 16.51 31.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.21,14.06a1.87,1.87,0,0,1-.15-3.73,2.26,2.26,0,0,1,.6-1.55,2.28,2.28,0,0,1,3.24-.15,2.31,2.31,0,0,1,.75,1.82,1.84,1.84,0,0,1,.66-.12,1.87,1.87,0,1,1,0,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.25,31.31h-.74L9.88,37.94A6.32,6.32,0,0,0,8,42.42,7.86,7.86,0,0,1,10.23,40h0a3,3,0,0,1,3-2.53,3,3,0,0,1,.85.14A3.61,3.61,0,0,1,20,36.49V34.8H15.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.57 37.78 21.57 37.78 21.57 37.78 21.57 37.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.28,37.94,29.09,27.75a6.29,6.29,0,0,0-4.33-1.86l.54,1H23.76l2.53,4.46h-2l2,3.49H21.57v2.51a5.36,5.36,0,0,1,.69-.06,4.47,4.47,0,0,1,3.85,2.21H26a8.22,8.22,0,0,1,3,3H41.15A6.31,6.31,0,0,0,39.28,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,24.88a1.86,1.86,0,0,1-.15-3.72,2.3,2.3,0,0,1,3.85-1.71,2.27,2.27,0,0,1,.74,1.82,1.89,1.89,0,0,1,.67-.12,1.87,1.87,0,1,1,0,3.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24.31 31.31 26.28 34.8 15.27 34.8 17.25 31.31 15.27 31.31 17.79 26.85 16.25 26.85 20.78 18.85 25.29 26.85 23.76 26.85 26.28 31.31 24.31 31.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.47,37.47a15.16,15.16,0,0,1,1.52.08V36.49A3.62,3.62,0,0,0,14,37.57a3,3,0,0,0-.84-.14,3,3,0,0,0-3,2.53A13.86,13.86,0,0,1,18.47,37.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26,39.46h.13a4.44,4.44,0,0,0-3.84-2.21,5.36,5.36,0,0,0-.7.06v.47A13,13,0,0,1,26,39.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.56,37.78v-3H20v2.75A15.6,15.6,0,0,1,21.56,37.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.94,42.44c-1.58-2.9-5.67-5-10.47-5S9.58,39.54,8,42.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "22.79 22.41 24.89 21.26 25.98 22.7 27.74 21.98 29.79 22.7 30.92 21.74 33.09 22.7 33.28 22.12 33.38 22.17 28 14.19 22.64 22.14 22.79 22.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel3Selected);
export default __webpack_public_path__ + "static/media/icon_level_3_selected.8317d8ebb76cd84051bdcd60764af2b3.svg";
export { ForwardRef as ReactComponent };